import React from 'react';
import styled from 'styled-components';

import CuratedLinkTable from 'homepage/components/brandsListSection/CuratedLinkTable';
import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { NUM_OF_ROWS_IN_BRAND_LIST_TABLE } from 'homepage/enums/contentConstants';
import { splitCuratedLinksIntoList } from 'homepage/utils/splitCuratedLinksIntoList';
import { useTriggerSwipeEvent } from 'homepage/hooks/useTriggerSwipeEvent';

/**
 * <CuratedLinkTableCarousel>
 * Splits links into "pages" of 7 links, and renders them in a carousel.
 * @param       {Array} curatedLinks The curated links to show.
 */
export const CuratedLinkTableCarousel = ({ moduleTrackingData, curatedLinks = [] }) => {
  const curateLinkSets = splitCuratedLinksIntoList(curatedLinks);
  const { trackScrollEvent } = useTriggerSwipeEvent(moduleTrackingData);
  return (
    <CuratedLinkTableCarousel.Container onScroll={trackScrollEvent}>
      {curateLinkSets.map((page, index) => {
        return (
          <CuratedLinkTableCarousel.Card
            key={page.curatedLinkIdHash}
            curatedLinks={page.items}
            moduleTrackingData={moduleTrackingData}
            pageOffset={index * NUM_OF_ROWS_IN_BRAND_LIST_TABLE}
          />
        );
      })}
    </CuratedLinkTableCarousel.Container>
  );
};

CuratedLinkTableCarousel.Container = styled.div`
  display: flex;
  width: 100%;
  overflow-x: scroll;
  ${hideScrollbars}
`;

CuratedLinkTableCarousel.Card = styled(CuratedLinkTable)`
  flex: 0 0 100%;
  max-width: 639px;

  -webkit-scroll-snap-align: start;
  scroll-snap-align: start;
`;
